import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { DreTipoPreenchimento } from 'pages/financeiro/dre/configuracao/types';

export function DreTipoPreenchimentoAutoComplete({ sx, name, value, error, size, disabled = false, onChange = () => {} }: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            label="Tipo de preenchimento"
            objectId="idDreTipoPreenchimento"
            optionStringTemplate="{dsDreTipoPreenchimento}"
            selectedStringTemplate="{dsDreTipoPreenchimento}"
            sx={sx}
            size={size}
            name={name}
            value={value}
            error={error}
            onChange={onChange}
            disabled={disabled}
            multiple={false}
            isOptionEqualToValue={(option: DreTipoPreenchimento, value: DreTipoPreenchimento) =>
                option.idDreTipoPreenchimento === value.idDreTipoPreenchimento
            }
            requestOptions={{
                url: '/dre/dretipopreenchimento',
                sort: [{ property: 'idDreTipoPreenchimento', direction: 'ASC' }],
                nested: true,
            }}
        />
    );
}
